'use client'
import React from 'react'

export default function Loading({ className, ...props }: any) {
  return (
    <h4
      className={`bg-button-dark rounded-lg border-c-dark font-medium text-base pl-4 py-3 mt-6 relative flex items-center justify-between ${
        className || ''
      }`}
      {...props}
    >
      <span>
        Loading<span className='text-primary-500'>...</span>
      </span>
      <span className='animate-ping h-2 w-2 mr-5 rounded-full bg-primary-500'></span>
    </h4>
  )
}
